import { getAppRunUuid } from '@nsftx/seven-client-retail-vue-common'

export const redirectToSboLogin = (): void => {
  const appRunUuid = getAppRunUuid()

  const url = new URL(import.meta.env.VITE_SBO_URL + '/login')
  url.searchParams.set('appRunUuid', appRunUuid?.toString() || '')

  window.location.href = url.toString()
}
